import { get, put } from './request'

interface ODS {
    supplier: string;
    propertyId: string;
    property: {
        otherdistributionsystems: object[]
    };
}


export const getODSs = (supplier: string, propertyid: string) => get(`/property/otherdistributionsystems?supplier=${supplier}&propertyid=${propertyid}`)

// if id is not sent it is an add else it is an update
// export const addODSs = (ods: ODS) => post('/property/otherdistributionsystems', ods)
export const updateODSs = (ods: ODS) => put('/property/otherdistributionsystems', ods)
